import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { api } from '../api';

const COLORS = {
  present: { bg: '#dcfce7', fg: '#166534', label: 'Present' },
  half: { bg: '#fef3c7', fg: '#92400e', label: 'Half day' },
  absent: { bg: '#fee2e2', fg: '#b91c1c', label: 'Absent' },
  off: { bg: '#f1f5f9', fg: '#475569', label: 'Off' },
  none: { bg: '#f8fafc', fg: '#94a3b8', label: 'Not marked' },
};
const norm = (s) => { s = String(s || '').toLowerCase(); return s.startsWith('half') ? 'half' : s.startsWith('abs') ? 'absent' : s.startsWith('off') || s.startsWith('leave') || s.startsWith('week') ? 'off' : s.startsWith('pres') ? 'present' : 'none'; };
const istToday = () => new Date(Date.now() + 1.5 * 3600000).toISOString().slice(0, 10);
const WD = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const nice = (d) => { const x = new Date(d + 'T00:00:00'); return `${x.getDate()} ${x.toLocaleString('en-IN', { month: 'short' })} (${WD[(x.getDay() + 6) % 7]})`; };

function StaffHistory() {
  const [who, setWho] = useState(null);
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    const open = (e) => { setWho(e.detail); setData(null); setErr(''); };
    const esc = (e) => { if (e.key === 'Escape') setWho(null); };
    window.addEventListener('staff-history', open); window.addEventListener('keydown', esc);
    return () => { window.removeEventListener('staff-history', open); window.removeEventListener('keydown', esc); };
  }, []);
  useEffect(() => {
    if (!who) return;
    api.get(`/staff/attendance/history?employee_id=${who.id}&month=${String(who.month).slice(0, 7)}`).then(setData).catch((e) => setErr(e.message));
  }, [who]);
  if (!who) return null;

  const month = String(who.month).slice(0, 7);
  const [y, mo] = month.split('-').map(Number);
  const days = new Date(y, mo, 0).getDate();
  const first = (new Date(y, mo - 1, 1).getDay() + 6) % 7;
  const today = istToday();
  const join = data && data.join_date ? String(data.join_date).slice(0, 10) : null;
  const byDate = {}; ((data && data.rows) || []).forEach((r) => { byDate[r.date.slice(0, 10)] = r; });
  const cells = []; const lists = { absent: [], half: [], off: [], none: [] }; const count = { present: 0, half: 0, absent: 0, off: 0, none: 0 };
  for (let d = 1; d <= days; d++) {
    const ds = `${month}-${String(d).padStart(2, '0')}`;
    const future = ds > today; const before = join && ds < join;
    const r = byDate[ds]; let st = r ? norm(r.status) : (future || before ? null : 'none');
    if (st) { count[st]++; if (lists[st]) lists[st].push({ ds, note: r && r.note }); }
    cells.push({ d, ds, st, note: r && r.note });
  }
  const box = { position: 'fixed', inset: 0, background: 'rgba(20,14,38,.45)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 };
  const List = ({ k }) => lists[k].length ? (
    <div style={{ marginTop: 10, fontSize: 14 }}>
      <strong style={{ color: COLORS[k].fg }}>{COLORS[k].label} ({lists[k].length}):</strong>{' '}
      {lists[k].map((x, i) => <span key={x.ds}>{i ? ', ' : ''}{nice(x.ds)}{x.note ? ` – ${x.note}` : ''}</span>)}
    </div>) : null;

  return (
    <div style={box} onMouseDown={() => setWho(null)}>
      <div onMouseDown={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 18, width: 'min(560px, 100%)', maxHeight: '88vh', overflowY: 'auto', padding: 20, boxShadow: '0 24px 70px rgba(0,0,0,.25)', fontFamily: 'inherit', color: '#231a33' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontSize: 19, fontWeight: 800 }}>{who.name}</div>
            <div style={{ fontSize: 13, color: '#776e86' }}>Attendance · {new Date(y, mo - 1, 1).toLocaleString('en-IN', { month: 'long', year: 'numeric' })}</div>
          </div>
          <button type="button" onClick={() => setWho(null)} style={{ border: 0, background: '#f3f4f6', borderRadius: 8, width: 34, height: 34, cursor: 'pointer', fontSize: 16 }}>✕</button>
        </div>
        {err && <div style={{ color: '#b91c1c', marginTop: 10 }}>{err}</div>}
        {!data && !err && <div style={{ padding: 30, textAlign: 'center', color: '#776e86' }}>Loading…</div>}
        {data && (
          <>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '14px 0' }}>
              {['present', 'half', 'absent', 'off', 'none'].map((k) => (
                <span key={k} style={{ background: COLORS[k].bg, color: COLORS[k].fg, borderRadius: 999, padding: '4px 10px', fontSize: 13, fontWeight: 700 }}>{COLORS[k].label}: {count[k]}</span>
              ))}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 6 }}>
              {WD.map((w) => <div key={w} style={{ textAlign: 'center', fontSize: 11, fontWeight: 700, color: '#8b84a0' }}>{w}</div>)}
              {Array.from({ length: first }).map((_, k) => <div key={'b' + k} />)}
              {cells.map((c) => {
                const col = c.st ? COLORS[c.st] : { bg: '#fff', fg: '#cbd5e1' };
                return (
                  <div key={c.ds} title={c.st ? `${nice(c.ds)}: ${COLORS[c.st].label}${c.note ? ' – ' + c.note : ''}` : ''}
                    style={{ background: col.bg, color: col.fg, borderRadius: 10, height: 46, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontWeight: 700, border: c.ds === today ? '2px solid #6948dc' : '1px solid #eef0f4' }}>
                    <span style={{ fontSize: 15 }}>{c.d}</span>
                    <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: '.04em' }}>{c.st === 'present' ? 'P' : c.st === 'half' ? '½' : c.st === 'absent' ? 'A' : c.st === 'off' ? 'OFF' : c.st === 'none' ? '?' : ''}</span>
                  </div>
                );
              })}
            </div>
            <List k="absent" /><List k="half" /><List k="off" /><List k="none" />
          </>
        )}
      </div>
    </div>
  );
}

export function mountStaffHistory() {
  if (document.getElementById('staff-history-root')) return;
  const el = document.createElement('div'); el.id = 'staff-history-root'; document.body.appendChild(el);
  createRoot(el).render(<StaffHistory />);
}
